import PropTypes from 'prop-types'
import { Component } from 'react'

export default class AddGiosg extends Component {
  componentDidMount() {
    const { enableGiosg } = this.props
    const giosg = document.querySelector('script[src="https://service.giosg.com/live/"]')
    if (enableGiosg && !giosg) {
      (function(w, t, f) {
        var s='script',o='_giosg',h='https://service.giosg.com',e,n;e=t.createElement(s);e.async=1;e.src=h+'/live/';
        w[o]=w[o]||function(){(w[o]._e=w[o]._e||[]).push(arguments)};w[o]._c=f;w[o]._h=h;n=t.getElementsByTagName(s)[0];n.parentNode.insertBefore(e,n);
      })(window,document, 4855)
    }
  }

  render() {
    return null
  }
}

AddGiosg.propTypes = {
  enableGiosg: PropTypes.bool,
}

AddGiosg.defaultProps = {
  enableGiosg: false,
}
